export * from "./libraryBase";

import {
    createReaction as baseCreateReaction,
    updateReaction as baseUpdateReaction,
} from "./libraryBase";
import {
    toReactionCreateRequest,
    toReactionUpdateRequest,
} from "../../domain/reactions/reactionPersistencePayloads";

type CreateReactionActionArgs = NonNullable<
    Parameters<typeof baseCreateReaction.action>[0]
>;
type UpdateReactionActionArgs = NonNullable<
    Parameters<typeof baseUpdateReaction.action>[0]
>;

/**
 * Defensive action facades keep stale derived fields and copied relationship
 * identities out of every reaction persistence request, regardless of caller.
 */
export const createReaction = {
    ...baseCreateReaction,
    action: (args: CreateReactionActionArgs = {}) =>
        baseCreateReaction.action({
            ...args,
            body: args.body ? toReactionCreateRequest(args.body) : args.body,
        }),
};

export const updateReaction = {
    ...baseUpdateReaction,
    action: (args: UpdateReactionActionArgs = {}) =>
        baseUpdateReaction.action({
            ...args,
            body: args.body ? toReactionUpdateRequest(args.body) : args.body,
        }),
};
